import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRecommendations() {
  const hotComics = comics.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="hot-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">编辑推荐</span>
              <h2 id="hot-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
                热门<span className="italic font-normal text-accent-500">推荐</span>
              </h2>
            </div>
            <Link to="/category/rexue" className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {hotComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="aspect-[3/4] overflow-hidden relative">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                      comic.status === '连载中'
                        ? 'bg-accent-500/90 text-background-50'
                        : 'bg-foreground-700/80 text-background-50'
                    }`}>
                      {comic.status}
                    </span>
                  </div>
                  <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-10">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-400 text-xs"></i>
                      <span className="text-background-50 text-sm font-semibold">{comic.rating}</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-sans text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <p className="text-xs text-foreground-400 mt-2 line-clamp-2">{comic.description}</p>
                </div>
              </Link>
            ))}
          </div>

          <div className="flex sm:hidden justify-center mt-6">
            <Link to="/category/rexue" className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              查看全部热门推荐 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}